
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

interface Subscription {
  id: string;
  status: string;
  end_date: string | null;
  plan: {
    id: string;
    name: string;
    type: string;
    duration: number;
    feature_id: string;
  };
}

export const useUserSubscriptions = (isOpen: boolean, productId: string | undefined) => {
  const [userSubscriptions, setUserSubscriptions] = useState<Subscription[]>([]);

  useEffect(() => {
    const fetchUserSubscriptions = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user?.email) return;

        const { data: schoolUser } = await supabase
          .from('school_users')
          .select('school_id')
          .eq('email', user.email)
          .maybeSingle();

        if (!schoolUser) return;

        const { data: client } = await supabase
          .from('clients')
          .select('id')
          .eq('school_id', schoolUser.school_id)
          .maybeSingle();

        if (!client) return;

        const { data: subscriptions } = await supabase
          .from('subscriptions')
          .select(`
            id,
            status,
            end_date,
            plan:plans (
              id,
              name,
              type,
              duration,
              feature_id
            )
          `)
          .eq('client_id', client.id)
          .in('status', ['active', 'pending']);

        if (subscriptions) {
          setUserSubscriptions(subscriptions);
        }
      } catch (error) {
        console.error('Error fetching subscriptions:', error);
      }
    };

    if (isOpen && productId) {
      fetchUserSubscriptions();
    }
  }, [isOpen, productId]);

  return userSubscriptions;
};
